import type { List as TList }                from 'immutable';
import { List }                              from 'immutable';
import handleActions                         from 'redux-actions/lib/handleActions';
import { combineReducers }                   from 'redux-immutable';
import type { AddPathToRouterHistoryAction } from '../actions/router/addPathToRouterHistory';
import addPathToRouterHistory                from '../actions/router/addPathToRouterHistory';
import removePathFromRouterHistory           from '../actions/router/removePathFromRouterHistory';
import replacePathInRouterHistory            from '../actions/router/replacePathInRouterHistory';
import type { LocationRecord }               from '../modules/react-router/domain/react-router.domain';

const pathHistory = handleActions(
  {
    [addPathToRouterHistory](state: TList<LocationRecord>, action: AddPathToRouterHistoryAction) {

      const {payload: {location}} = action;

      return state.push(location);

    },

    [replacePathInRouterHistory](state: TList<LocationRecord>, action: ReplacePathInRouterHistoryAction) {

      const {payload: {location}} = action;

      return state.pop().push(location);

    },

    [removePathFromRouterHistory](state: TList<LocationRecord>) {

      return state.pop();

    },
  },
  List(),
);

export default combineReducers({pathHistory});


// WEBPACK FOOTER //
// ./src/reducers/routerHistory.js